import { useThree } from '@react-three/fiber'
import { StaticScene } from '../../three/scene'
import { DirectionalLight } from '../../three/light'
import { HouseLight } from '../light/HouseLight'
import { useVerandaSelector } from '../..'
import { useEffect, useState } from 'react'
import { Suspense } from 'react'
import { screenshot } from '../utility'
import { SuspenseLoader } from '../../components/suspense'
import { useMeasures } from '../../hooks/state/useMeasures'
// import { BloomPass } from '../utility/light/BloomPass'

interface Props {
  children?: React.ReactNode
}

export const Layout = ({ children }: Props): JSX.Element => {
  const nightMode = useVerandaSelector((state) => state.scene.nightMode)
  const state = useThree((state) => state)
  // @ts-ignore
  window.screenshot = screenshot(state)

  const three = useThree()
  const [initialized, setInitialized] = useState(false)
  useEffect(() => {
    if (!initialized && three?.scene?.children?.length) {
      setInitialized(true)
    }
  }, [three, nightMode])

  return (
    <>
      <Suspense fallback={<SuspenseLoader />}>
        {!nightMode && (
          <DirectionalLight position={[10, 15, 20]} intensity={0.75} />
        )}

        {!nightMode && (
          <spotLight
            color="#ffffff"
            intensity={0.25}
            position={[0, -2.5, -1]}
            angle={Math.PI / 4 / 2}
            penumbra={0.5}
            decay={2}
          />
        )}
        {/* {nightMode && <BloomPass nightMode={nightMode} />} */}
        <HouseLight lightsOn={nightMode} />
        <hemisphereLight intensity={nightMode ? 0.075 : 0.05} color="#eaeaea" />
        {nightMode && (
          <DirectionalLight position={[10, 8, 12]} intensity={0.025} />
        )}
      </Suspense>

      <StaticScene />
      {children}

      {!initialized && children}
    </>
  )
}
